export default __webpack_public_path__ + "static/media/style.5e5359f3.less";